<template>
  <modal content-class="marketing-automation-create"
         :title="$t('message.automation.message.newAutomation')"
         :value="showing"
         :maxWidth="500"
         @input="emitShowing">

    <app-form @submit="create">
      <text-field class="marketing-automation-create-name"
                  v-model="form.name"
                  :label="$t('message.automation.message.automationName')"
                  name="Nome da automação"
                  :help="$t('message.automation.message.tooltipAutomationName')"
                  validate="required" />

      <button class="marketing-automation-create-action btn btn-primary btn-round"
              type="submit">
          {{$t('message.automation.message.createAutomation')}}
      </button>
    </app-form>

  </modal>
</template>

<script>
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import Modal from "@components/generic/Modal.vue";

export default {
  components: {
    Modal,
    AppForm,
    TextField,
  },

  props: {
    showing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        name: "",
      },
    };
  },

  methods: {
    emitShowing(showing) {
      this.$emit("update:showing", showing);
    },
    async create() {
      const newAutomation = await this.$api.marketing.automation.flow.create({
        name: this.form.name,
      });

      this.$emit("created", newAutomation.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-create {
  .marketing-automation-create-name {
    margin-bottom: 40px;
  }

  .marketing-automation-create-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
